import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class ServiceV5 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div className="ltn__service-area section-bg-1 pt-115 pb-70 go-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                  Our Services
                </h6>
                <h1 className="section-title">Our Core Services</h1>
              </div>
            </div>
          </div>
          <div className="row  justify-content-center">
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="flaticon-house" />
                  </span>
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <Link to="/property-management">Property Management</Link>
                  </h3>
                  <p>
                    We stand by our policy of giving our clients peace of mind,
                    working with all parties to know the building in depth,
                    ensuring all aspects of the building are covered.
                  </p> <br />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="flaticon-mortgage" />
                  </span>
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <Link to="/residential-management">
                      Residential Management
                    </Link>
                  </h3>
                  <p>
                    In the Quoin Management team's care, our clients' premises
                    are maintained to an excellent standard for the safety and
                    security of residents.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="flaticon-operator" />
                  </span>
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <Link to="/commercial-management">
                      Commercial Management
                    </Link>
                  </h3>
                  <p>
                    Quoin Management's commercial department endeavours to make
                    sure our clients reach their full potential, using a
                    tailored plan designed by our team of experts.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="flaticon-house-1" />
                  </span>
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <Link to="/compliance-management">
                      Compliance Management
                    </Link>
                  </h3>
                  <p>
                    At Quoin Management, we take pride in keeping up to date with
                    the latest changes in legislation and regulations for the
                    benefit of our
                    clients within the property industry.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="flaticon-house-3" />
                  </span>
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <Link to="/legal">Legal</Link>
                  </h3>
                  <p>
                    Quoin Management's legal experts work alongside our
                    management department, ensuring that you receive an integrated
                    support package from our team.
                  </p> <br />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="flaticon-official-documents" />
                  </span>
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <Link to="/emergency-response">Emergency Response</Link>
                  </h3>
                  <p>
                    Here at Quoin Management, we understand that emergencies
                    happen, so we help our clients prepare for them and respond well.
                  </p> <br /> <br /> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ServiceV5;
